export default __webpack_public_path__ + "static/media/usa-flag.e0086949.png";